import React, { FC } from 'react';
import { ChatContainer } from '../chat';
import { InformationContainer } from '../info';
import style from './style.module.less';

export const Home: FC = () => {
  return (
    <div className={style.container}>
      <div className={style.information}>
        <InformationContainer />
      </div>
      <div className={style.chat}>
        <ChatContainer />
      </div>
    </div>
  );
};
